import { Component, Input } from "@angular/core";

@Component({
    selector: "app-chevron-icon",
    templateUrl: "./chevron-icon.component.html",
    styleUrls: ["./chevron-icon.component.css"],
    standalone: false
})
export class ChevronIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;
    @Input() direction: "up" | "down" = "down";
}
